module.exports = __webpack_public_path__ + "static/Rappi-58d9f43d36f39b8120c7c5301fbcf511.jpg";